
  import { Component,
    Model,
    Prop, Vue, Watch } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import Dialog from '@/components/dialog.vue';
	import html2canvas from 'html2canvas';
	import {imgHost} from '@/utils/config'
  import {
    // mallgetQrCode
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-dialog': Dialog,
    }
  })

  export default class ProductList extends Vue {
    @Model('change') isShow!: boolean;
    @Prop({default:{}}) codemsg!:Object
    private imgHost = imgHost
    private show = false
    private imgloading = false
    private imgcode = ''
    private downimg = ''
    private msg:any = {}
    @Watch('isShow')
    private getshow(val){
      this.show = val
      if(val){
        this.msg = this.codemsg
        this.getimg()
      }
    }

    private close(){
      this.imgcode = ''
      this.downimg = ''
      this.$emit('close',false)
    }
    private download(){
      var image = new Image()
      // 解决跨域 Canvas 污染问题 解决跨域问题-并不好使，需要改对应的请求服务器
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = () => {
        var canvas:any = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height

        var context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        var url = canvas.toDataURL('image/png')

        // 生成一个a元素
        var a = document.createElement('a')
        // 创建一个单击事件
        var event = new MouseEvent('click')

        // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
        a.download = this.msg.title
        // 将生成的URL设置为a.href属性
        a.href = url
        // 触发a的单击事件
        a.dispatchEvent(event)
      }
      image.src = this.imgcode
      // console.log(image)
    }
    private geturl(){
      let data:any = {
        Page:'',
        Scene:''
      }
      if(this.msg.type==1){
        data.Page = 'pages/mall/detail/detail'
        data.Scene = 'id='+this.msg.Id
      }
      return data
    }
    private async getimg(){
      this.imgcode = require('@/assets/img/caf7a737ef60e0eaf0ed125e7ea747f.png')
      this.$nextTick(()=>{
        this.createCanvas();
      })
      // try{
      //   this.imgloading = true
      //   let data = {
      //     ...this.geturl(),
      //     IsLimited:false
      //   }
      //   let res = await mallgetQrCode(data)
      //   if(res.IsSuccess){
      //     this.imgcode = res.Result
          
      //     // console.log(imgHost+this.imgcode)
      //     // console.log('http://cdn2024.routuan.com/routuan'+this.imgcode)
      //   }
      // }finally{
      //   this.imgloading = false
      // }
    }
    private createCanvas(){
			html2canvas(document.getElementById('codeId'), {
				useCORS: true, // 【重要】开启跨域配置
				scale: 2,
				allowTaint: true, // 允许跨域图片
        scrollX:0,
        scrollY:0,
        logging:false
			}).then((canvas)=>{
        // console.log(canvas)
				this.downimg = canvas.toDataURL('image/jpeg');
			});
		}
  }
